import widgetsMgr from 'widgets/widgetsMgr';

const hasContext = (context: string) => window.contexts.includes(context);

widgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('content') || hasContext('clp'),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'content.contactUs' */ './widgets/content/ContactUsForm').then(d => d.default)]).then(deps => {
            const [ContactUsForm] = deps;

            return {
                listId: 'content.contactUs',
                widgetsDefinition: () => [['contactUsForm', ContactUsForm, 'ajaxform']]
            };
        })
});
